<template>
  <div class="contain">
    <div class="exception">
      <div class="exception-img">
        <img src="~@/assets/imgs/404.svg" width="100%">
      </div>
      <div class="exception-content">
        <p class="exception-number">404</p>
        <p class="exception-text">抱歉，你访问的页面不存在</p>
        <a class="exception-back" @click="$router.go(-1)">点击此处返回</a>
      </div>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style scope="scoped">
.contain {
  position: relative;
  height: 100vh;
}
.exception {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
}
.exception-img {
  padding-right: 88px;
  width: 100%;
  max-width: 430px;
}
.exception-content {
  flex: auto;
}
.exception-number {
  margin-bottom: 24px;
  color: #434e59;
  font-weight: 600;
  font-size: 72px;
  line-height: 72px;
}
.exception-text {
  margin-bottom: 16px;
  color: rgba(0, 0, 0, 0.45);
  font-size: 20px;
  line-height: 28px;
}
.exception-back {
  font-size: 16px;
  line-height: 24px;
}
</style>